import { useEffect, useState } from 'react';
import Logo from './Logo';
import { InstagramIcon } from './icons';
import { INSTAGRAM_URL, NAV_LINKS, APP_STORE_URL } from '../constants';
import './Navbar.css';

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Lock body scroll while the mobile menu is open.
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  const close = () => setOpen(false);

  return (
    <header className={`nav ${scrolled ? 'nav--scrolled' : ''}`}>
      <div className="container nav__inner">
        <a href="#top" className="nav__brand" onClick={close} aria-label="Peek home">
          <Logo />
        </a>

        <nav
          className={`nav__menu ${open ? 'is-open' : ''}`}
          aria-label="Primary"
        >
          {NAV_LINKS.map((link) => (
            <a key={link.href} href={link.href} className="nav__link" onClick={close}>
              {link.label}
            </a>
          ))}
          <a
            href={INSTAGRAM_URL}
            className="nav__link nav__link--icon"
            target="_blank"
            rel="noopener noreferrer"
            onClick={close}
          >
            <InstagramIcon />
            <span>Instagram</span>
          </a>
          <a
            href={APP_STORE_URL}
            className="nav__cta"
            target="_blank"
            rel="noopener noreferrer"
            onClick={close}
          >
            Download
          </a>
        </nav>

        <button
          type="button"
          className={`nav__toggle ${open ? 'is-open' : ''}`}
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {open && (
        <button
          type="button"
          className="nav__scrim"
          aria-label="Close menu"
          onClick={close}
        />
      )}
    </header>
  );
}
